export default {
    activateuser: {
        headerLabel: 'Подключить пользователя',
        accountActivation: 'Активация аккаунта',
        step1: {
            header: 'Добро пожаловать на нашу платформу!',
            subHeader: 'Выберите, способ входа в учетную запись.',
            description:
                'Для упрощения процесса входа мы рекомендуем вам подключить свою учетную запись хотя бы к одной из следующих служб.',
            OR: 'или',
            emailAndPassword: 'Использовать электронную почту',
        },
        step2: {
            header: 'Используйте электронную почту и пароль',
            description:
                'Это основной адрес электронной почты, который будет связан с вашей учетной записью. Мы рекомендуем использовать адрес электронной почты, отличающийся от адреса университета, чтобы сохранить доступ к своим данным после окончания учебы. Вы можете легко контролировать, какие электронные письма вы получаете от нас, в настройках своей учетной записи.',
            invalidEmail: 'Указанный адрес электронной почты не является действительным.',
            passwordsNotMatch: 'Пароли должны совпадать',
            passwordDescription01:
                'Для обеспечения безопасности вашей учетной записи вам необходимо установить новый пароль. Пожалуйста, создайте пароль содержащий:',
            passwordDescription02: 'Минимум 8 символов',
            passwordDescription03: 'Минимум один символ нижнего регистра (a-z)',
            passwordDescription04: 'Минимум один символ верхнего регистра (A-Z)',
            passwordDescription05: 'Минимум одна цифра или специальный символ (0-9,! # $ И т. Д.)',
            passwordDescription06: 'Минимум 6 специальных символов',
            repeatPassword: 'Повторите пароль',
        },
        step3: {
            header: 'Активация пользователя',
            loadingHints: {
                0: 'Загрузка пользовательских данных',
                1: 'Загружаем данные',
                2: 'Новые возможности уже рядом',
                3: 'Почти готово!',
            },
            successHeader: 'Теперь ваша учетная запись готова к работе!',
            successSubheader: 'Теперь у вас есть доступ к эксклюзивным функциям!',
            errorHeader: 'Не удалось активировать аккаунт',
            ifWrongContact: 'Если вы обнаружили ошибку, пожалуйста, обратитесь в службу поддержки.',
            contactForHelp: 'Обратиться за помощью',
            goBack: 'Вернуться',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Проверить мой прогресс',
            getStarted: 'Начать!',
            getToKnowYourself: 'Начать изучение себя',
            getToKnowYourselfBold: 'Познакомьтесь с <strong> собой </strong>',
            getToKnowYourFuture: 'Узнайте свое будущее',
            getToKnowYourFutureBold: 'Узнайте свое <strong> будущее </strong>',
            openAssessments: 'Открыть оценки',
            openAssessment: 'Открыть оценку',
            unlock: 'Разблокировать тесты',
            testYourself: 'Пройти тестирование',
            takeTheFreeTests: 'Пройти бесплатные тесты',
            youOwnThisProduct: 'Вы являетесь владельцем этого продукта',
            startTest: 'Начать тест',
            startTests: 'Начать тесты',
            continue: 'Продолжить',
            showReport: 'Показать отчет',
            showYourReports: 'Показать свои отчеты',
            showYourReport: 'Показать свой отчет',
            continueFreeTests: 'Продолжить бесплатные тесты',
            continueTheTest: 'Продолжить тест',
            estimatedTime: '~ {мин} мин.',
        },
        landing: {
            section1: {
                title: 'Попробуй себя',
                description01:
                    'Добро пожаловать в Центр оценки - здесь начинается ваш карьерный путь.',
                description02:
                    'Здесь вы можете пройти <strong> Aon Assessments </strong>, тесты, используемые рекрутерами по всему миру, которые проверяют ваши способности и готовность к будущей карьере.',
                freemium: {
                    description:
                        'Пройдите эти тесты, чтобы измерить свои сильные стороны и получить эффективные отчеты о своих навыках.',
                    price: 'Бесплатно',
                    numTests: '3 теста',
                    timeEstimated: 'Приблезительно 27 мин.',
                },
                premium: {
                    description:
                        'Это <strong> настоящая сделка </strong>. Пройдите этот тест 3-в-1, чтобы узнать, какой карьерный путь вам следует выбрать, и получите полный отчет кандидата.',
                    numTests: 'Тест 3-в-1',
                    timeEstimated: 'Приблизиьельно 60 мин.',
                    sampleReport: '↓ Скачать образец отчета',
                    candidateReport: 'Отчет кандидата',
                    candidateReportDescription:
                        'После того, как вы завершите эти тесты, вы получите полный отчет кандидата с подробным обзором ваших результатов, включая советы по улучшению вашего личного набора навыков, на какие навыки вам следует обратить внимание, лучшие возможности для начала, каким должен быть ваш следующий шаг, и многое другое.',
                },
            },
            section2: {
                title: 'Как эти тесты помогут вам получить работу?',
                t1: 'Вы узнаете свои <strong> навыки </strong>',
                t2: 'Вы реализуете свой <strong> потенциал </strong>',
                t3: 'У вас будет четкий <strong> карьерный путь </strong>',
                t4: 'Вы повысите свою <strong> уверенность </strong>',
            },
            section3: {
                title: 'Узнайте о своих личных сильных сторонах и возможностях карьерного роста, чтобы стимулировать ваше развитие и карьерный рост.',
            },
            section4: {
                title: 'Опередите своих конкурентов сегодня',
                description:
                    'путем выполнения оценок, используемых рекрутерами по всему миру в таких компаниях, как Deloitte, Siemens, Burger King, Vodafone или P&G.',
            },
            section5: {
                title: 'Часто задаваемые вопросы',
                thisPage: 'эта страница',
                question01: {
                    q: 'Что такое оценки Aon?',
                    a: 'Оценка талантов от Aon - это всемирно признанные тесты, которые помогают компаниям во всем мире определять лучших кандидатов на работу. С помощью оценки талантов рекрутеры могут не ограничиваться резюме, школьными оценками, сертификатами колледжа и университетскими дипломами, чтобы узнать, подходит ли кандидат. \\ N <br> <br> \\ n Эти возможности обычно доступны <strong> только для рекрутерам </strong> - здесь вы получаете <strong> эксклюзивную </strong> возможность попрактиковаться и получить результаты до собеседования. У большинства кандидатов нет такой возможности, так что воспользуйтесь ею!',
                },
                question02: {
                    q: 'Нужно ли мне платить, чтобы пройти эти оценки?',
                    a: 'Вы можете бесплатно пройти 4 из этих тестов - <i> Поведение, связанное с работой </i>, <i> Численное мышление </i>, <i> Дедуктивно-логическое мышление </i> и <i> Индуктивное мышление. Логическое рассуждение </i>. Эти тесты позволяют оценить ваши навыки и способности и являются отличным способом выяснить ваши сильные и слабые стороны. \\ N \\ n <br> <br> Однако, если вы хотите получить полный обзор своих предрасположенностей, получите профессиональную информацию о Чтобы выбрать наиболее подходящий карьерный путь и сделать большой шаг к своему будущему успеху, вы также можете получить доступ к тесту 3-в-1 и получить исчерпывающий отчет кандидата за 79 евро. <br> <br> Чтобы получить расширенный доступ, просто <a href={premiumLink}> нажмите здесь </a> и оплатите картой - мы используем безопасный способ оплаты. \\ n',
                },
                question03: { q: 'Зачем мне сдавать эти тесты?' },
                question04: {
                    q: 'Как я могу подготовиться к этим тестам?',
                    a: 'Вы можете прочитать все о технических требованиях и о том, как подготовиться к экзаменам, на <a href={link} target="_blank"> этой странице </a>. Там вы также найдете материалы, которые помогут вам в этом',
                },
                question05: {
                    q: 'Где еще я могу найти эти оценки?',
                    a: 'Как правило, рекрутер может попросить вас пройти эти тесты - кроме этого, вы больше нигде не найдете эти тесты. Это эксклюзивная возможность попрактиковаться, узнать больше о себе и о своей будущей карьере.',
                },
                question06: {
                    q: 'Сколько раз я могу проходить тесты?',
                    a: 'Вам доступна только одна попытка для каждого теста. Никаких пересдач! Убедитесь, что у вас есть комфортные условия, чтобы воспользоваться этой возможностью. Вы можете ознакомиться с тестом, посмотрев обучающие видеоролики и выполнив практические упражнения перед прохождением теста.',
                },
                question07: {
                    q: 'На каком языке эти тесты?',
                    a: '\\ n Языком по умолчанию для этих тестов является английский, однако для каждого из них есть несколько языков на выбор. Вы можете проверить, какие языки доступны, и выбрать тот, который вам больше всего подходит, прежде чем сдавать тест. \\ п',
                },
                question08: {
                    q: 'Есть ли у расширенных тестов срок годности после того, как я заплачу за них?',
                    a: 'Нет! После того, как ваш платеж будет принят, вы сможете пройти расширенные тесты в любое время. Не торопитесь, чтобы подготовиться и приступить к экзаменам в любое удобное для вас время.',
                },
            },
        },
        center: {
            banner: {
                title: 'Посмотреть ваш прогресс',
                subtitle: 'Вот обзор вашего прогресса в оценке карьеры',
                moreInfo: 'Больше информации',
                yourProgress: 'Ваш прогресс',
                quote: 'Постановка целей - это первый шаг к превращению невидимого в видимое.',
            },
            list: {
                timeEstimated: 'Приблезително {минут} мин.',
                freemium: {
                    intro: '\\ n Это первый шаг на пути вашего личного развития! <br /> \\ n Пройдите эти тесты, чтобы измерить свои сильные стороны и получить эффективные отчеты о своих \\ n навыках. \\ n',
                },
                premium: {
                    intro: '\\ n Это действительно так. <br /> \\ n Пройдите эти тесты, чтобы выяснить, какой карьерный путь вам следует выбрать, и получите \\ n исчерпывающий <strong> отчет кандидата </strong>. \\ n',
                    description:
                        '\\ n Ваш <strong> Отчет кандидата </strong> предоставит вам исчерпывающий \\ n обзор ваших результатов, включая <strong> советы </strong> по улучшению \\ n набора личных навыков, на которые <strong> навыки </strong> вам следует обратить внимание, \\ n наилучшие <strong> возможности </strong> для начала, каким должен быть ваш \\ n <strong> следующий шаг </strong> и многое другое. \\ n',
                },
            },
            instruments: {
                344: {
                    name: 'Дедуктивно-логическое мышление',
                    description:
                        'Посмотрите, насколько хорошо вы используете знания и применяете правила - этот тест измеряет ваши аналитические способности и способности решать проблемы.',
                    estimatedTime: '9',
                },
                383: {
                    name: 'Индуктивно-логическое рассуждение',
                    description:
                        'Насколько хорошо вы можете определить правила и взаимосвязи? Этот тест поможет измерить ваши аналитические способности и способности решать проблемы.',
                    estimatedTime: '9',
                },
                390: {
                    name: 'Поведение, связанное с работой',
                    description:
                        'Какие личностные качества вы имеете? Узнайте, пройдя этот тест, который определяет ваши личностные характеристики, связанные с работой.',
                    estimatedTime: '30',
                },
                721: {
                    name: 'Математическое мышление',
                    description:
                        'Насколько хорошо вы справляетесь с вычислениями? Этот тест измеряет ваше понимание числовой информации и умение делать логические выводы.',
                    estimatedTime: '9',
                },
                5392: {
                    name: 'Работа памяти',
                    description:
                        'Насколько хорошо вы можете оставаться сосредоточенным? Этот тест измеряет способность обрабатывать и запоминать информацию в отвлекающих условиях.',
                    estimatedTime: '15',
                },
                82013: {
                    name: 'Тест на мобильность',
                    description:
                        'Какие у тебя интересы? Эта анкета поможет определить, какой карьерный путь вы можете выбрать.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Начать свою оценку Aon',
            consent:
                'Я понимаю, что Aon несет ответственность за мои данные, связанные с этой оценкой, и согласен с их условиями. \\ N Я также согласен с тем, что Highered может передать мое имя Aon для создания моего отчета.',
            startTest: 'Начать тест',
            consentErrorTitle: 'Ошибка согласия',
            consentErrorMessage:
                'Что-то пошло не так при отправке вашего согласия. Вы подтвердили свой адрес электронной почты?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats":
        {
            '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair':
                {
                    " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire":
                        {
                            '"': '\n                Các nhà tuyển dụng trên khắp thế giới sử dụng Bài kiểm tra đánh giá AON trong quá trình lựa chọn ứng viên của họ. Bằng cách hoàn thành chúng trước thời hạn và trình bày chúng với các báo cáo đã được chuẩn bị trước, bạn sẽ có cơ hội tuyệt vời để gây ấn tượng với các nhà tuyển dụng. Bằng cách nào? \n                <br><br>\n                Đầu tiên - hãy chuẩn bị cho phần của quy trình tuyển dụng đã được thực hiện, điều này sẽ khiến bạn ngay lập tức vượt lên trước các ứng viên khác.\n                <br><br>\n                Thứ hai - tiếp cận nhà tuyển dụng với một tâm trí rõ ràng. Hiểu rõ điểm mạnh của mình và những mục tiêu trong tương lai - với động lực mạnh mẽ và sự tự tin ! Các nhà tuyển dụng sẽ nhìn ra điều đó.',
                        },
                },
        },
    calendar: {
        header: 'Календарь',
        myCalendar: 'Мой календарь',
        noCalendar: 'В вашем сервисе карьеры еще не активна функция календаря',
        goBackBtn: 'Вернуться',
        calendarNotReady: 'Функционал «мой календарь» еще не готов. Скоро будет!',
        noUpcomingAppointments: 'У вас нет предстоящих встреч.',
        appointmentMissing: 'Встреча не активна',
        appointmentNotActive:
            'Извините, вы пытались просмотреть несуществующую или неактивную встречу.',
        appointmentNotHavingAvailability:
            'Извините, эта встреча в данный момент недоступна. Проверьте позднее.',
        appointmentMissingRules: 'Запись на встречу не предусмотрена',
        needToCompleteProfile: 'Заполните свой профиль',
        noUpcomingAppointmentsPleaseBook:
            'Запишитесь на прием, чтобы разблокировать свой календарь.',
        bookAppointment: 'Записаться на прием',
        bookAnotherAppointment: 'Записаться на прием',
        attendedAppointments: 'Встречи, которые вы посетили',
        aboutAppointments: {
            header: 'О встречах',
            button: 'О',
            block1: {
                header: 'Что такое встреча?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, conctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud упражнение ullamco labouris nisi ut aliquip ex ea Commodo Conquat. Duis aute irure dolor в репрехендерит в сладострастном velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, загорелся in culpa qui officia deserunt mollit anim id est Laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, conctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud упражнение ullamco labouris nisi ut aliquip ex ea Commodo Conquat. Duis aute irure dolor в репрехендерит в сладострастном velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, загорелся in culpa qui officia deserunt mollit anim id est Laborum.',
            },
            block2: {
                header: 'С кем я могу связаться для получения дополнительной информации?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, conctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud упражнение ullamco labouris nisi ut aliquip ex ea Commodo Conquat. Duis aute irure dolor в репрехендерит в сладострастном velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, загорелся in culpa qui officia deserunt mollit anim id est Laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, conctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud упражнение ullamco labouris nisi ut aliquip ex ea Commodo Conquat. Duis aute irure dolor в репрехендерит в сладострастном velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, загорелся in culpa qui officia deserunt mollit anim id est Laborum.',
            },
        },
        bookAnAppointment: 'Записаться на прием',
        backToCalendarBtn: 'Вернуться к календарю',
        backToBookingBtn: 'Вернуться к списку встреч',
        firstAvailable: 'Первый доступный',
        loadingAppointment: 'Загружается ...',
        bookModal: {
            title: 'Подтвердить бронирование',
            with: 'С',
            confirm: 'Подтвердить',
            continue: 'Продолжить',
            cancel: 'Закрыть',
            first: {
                title: 'Это ваша первая встреча',
                description:
                    'Чтобы убедиться, что вы получили приглашение на мероприятие, подтвердите, что у вас есть доступ к личному календарю через эту учетную запись электронной почты.',
                ok: 'хорошо',
                wrongEmail: 'Неправильный адрес электронной почты?',
            },
            changeEmail: {
                title: 'Выберите адрес электронной почты календаря',
                inputPlaceholder: 'Введите адрес электронной почты ...',
                ok: 'хорошо',
                back: 'По умолчанию',
            },
            unknownErrorHeader: 'Произошла ошибка при попытке забронировать',
            unknownErrorBody:
                'Пожалуйста, попробуйте забронировать в другой раз, и если это не сработает, обратитесь в службу поддержки.',
            confirmationHeader: 'Ваша встреча забронирована!',
            bookedTheFollowing: 'Подробности:',
            emailWillBeSent: 'Электронное письмо будет отправлено на адрес',
            withConfirmation: 'с просьбой подтвердить свое присутствие.',
        },
        dateDetailsModal: { title: ' Встреча на' },
        completedYourProfile:
            'Вам необходимо заполнить свой профиль, чтобы получить доступ к календарю',
        toMyProfile: 'Редактировать мой профиль',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} хочет видеть ваш профиль',
            content: 'Вы хотите поделиться своим профилем с этим человеком?',
            share: 'Поделиться профилем',
            reject: 'Нет',
        },
    },
    companyDetail: {
        locations: {
            header: 'Локации',
            viewAll: 'Увидеть все',
            noLocations: 'Нет локаций',
            allLocations: 'Все локации',
        },
        jobModule: {
            header: 'Топ позиции',
            viewAllJobs: 'Просмотреть все вакансии в {companyName}',
            noPositions: '{companyName} в настоящее время не имеет открытых вакансий в Highered.',
            defaultLabel: 'Открытые позиции',
        },
        videos: {
            header: 'Видео',
            noVideos: 'Нет видео',
            noMoreVideos: 'Больше нет видео',
            moreVideosFrom: 'Еще видео от компании {companyName}',
        },
        articles: {
            header: 'Статьи',
            noArticles: 'Нет статей',
            noMoreArticles: 'Больше никаких статей',
            moreArticlesFrom: 'Другие статьи от {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Создать' },
            yearMonthPicker: { defaultSelect: 'Выберите месяц' },
            localeDropdown: {
                languages: {
                    en: 'английский',
                    cn: 'китайский язык',
                    fr: 'французский язык',
                },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Подтвердите свою школьную электронную почту',
                description:
                    'Это быстрый процесс, который предоставит вам доступ к \\ n эксклюзивным функциям, таким как уникальные объявления о вакансиях, тесты навыков \\ n и ресурсы для карьерного роста.',
                verificationPending: 'Ожидается подтверждение',
                weHaveSentAnEmail:
                    'Мы отправили письмо на адрес \\ n <strong> {studentEmail} </strong>, чтобы \\ n вы подтвердили себя. Обязательно \\ n проверьте папку со спамом, так как многие школы \\ n очень строги к входящим письмам.',
                verifyMe: 'Подтвердить верификацию',
                resendVerifyEmail: 'Отправить письмо с подтверждением',
                cancelVerification: 'Отменить верификаию',
                emailSent: 'Письмо отправлено',
                emailSentMessage:
                    'Электронное письмо было успешно отправлено. Если вы его не получили, свяжитесь с нами по адресу support@highered.global.',
                resendErrorTitle: 'Ошибка при повторной отправке электронной почты',
                resendErrorMessage:
                    'Не удалось повторно отправить письмо с подтверждением. Свяжитесь с нами по адресу support@highered.global.',
                verificationCancelledTitle: 'Верификация отменена',
                verificationCancelledMessage: 'Верификация была успешно отменена.',
                cancelErrorTitle: 'Ошибка при отмене',
                cancelErrorMessage:
                    'Не удалось отменить верификацию. Свяжитесь с нами по адресу support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Подтвердите свою школьную электронную почту',
                university: 'Академический институт',
                studentEmail: 'Ваш академический адрес электронной почты',
                studentEmailPlaceholder: 'Академическая электронная почта',
                message: 'Сообщение',
                verify: 'Подвердить',
                sendRequest: 'Послать запрос',
                verificationInProcess: 'Проверка в процессе',
                emailHasBeenSentTo:
                    'Электронное письмо было отправлено на адрес <strong> {email} </strong>. Следуйте инструкциям, чтобы подтвердить подключение к <strong> {schoolName} </strong>.',
                verificationRequestSentNonAcademic:
                    'Служба карьерного роста в <strong> {schoolName} </strong> должна будет подтвердить ваше соединение. Когда это произойдет, вы получите уведомление по электронной почте.',
                ifNoEmailRecieved:
                    'Если вы не получили письмо с подтверждением, пожалуйста, свяжитесь с нами.',
                contactHelp: 'Свяжитесь с нами для получения помощи',
                doNotHaveAcademicEmail: 'У меня нет академического адреса электронной почты',
                doubleCheckEmail:
                    'Пожалуйста, дважды проверьте правильность этого адреса электронной почты и наличие к нему доступа.',
                haveAcademicEmail: 'У меня академический адрес электронной почты',
                noAcademicEmailInfo:
                    'Если вы не используете академический адрес электронной почты, ваш запрос должен быть одобрен службой карьеры вручную. Поэтому вы должны предоставить короткое сообщение, чтобы идентифицировать себя.',
                alreadyVerifiedInfo: 'Вы уже прошли проверку в этой школе.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Моя страница',
                jobs: 'Вакансии',
                companies: 'Компании',
                masterclasses: 'Мастер-классы',
                assessments: 'Оценки',
                countryGuides: 'Путеводители по странам',
                goToHaigui: 'Работа в Китае',
                signIn: 'Войти Зарегистрироваться',
                vfairs: 'Виртуальные события',
                events: 'События',
                newFeature: 'Новая функция!',
            },
            profileNavigation: { signOut: 'выход' },
            sidebar: {
                myPage: 'Моя страница',
                myProfile: 'Мой профайл',
                findJobs: 'Найти работу',
                findCompanies: 'Найти компании',
                masterclasses: 'Мастер-классы',
                assessments: 'Оценки',
                countryGuides: 'Путеводители по странам',
                goToHaigui: 'Работа в Китае',
                virtualFairs: 'Виртуальные события',
                logOut: 'Выйти',
            },
            backToCalendar: 'Вернуться к календарю',
            allBooths: 'Все будки',
            home: 'Дом',
        },
        smart: {
            companyModule: {
                followJob: 'Добавить в избранное',
                followCompany: 'Следить за компанией',
                unFollowJob: 'Удалить из Избранного',
                unFollowCompany: 'Отписаться от компании',
                favoritedTitle: 'Сохранено в избранное',
                favoritedMessage:
                    'Эта позиция сохранена в избранное. Найдите свои любимые позы на моей страничке.',
                unfavoritedTitle: 'Удалено из избранного',
                unfavoritedMessage: 'Эта позиция была удалена из избранного.',
                favoriteErrorTitle: 'Что-то пошло не так',
                favoriteErrorMessage: 'Не удалось добавить эту позицию в избранное',
                showAllCompanies: 'Показать все компании',
                showOnlyCompaniesLiveOnChat: 'Показывать в чате только компании в прямом эфире',
            },
            profileModule: {
                profileCompletion: 'Завершение профиля',
                profileCompletionEncouragement:
                    'Продемонстрируйте себя работодателям, заполнив последний {процентLeft} своего профиля.',
                gotoProfilePage: 'Обновить профиль',
                profileCompleted: 'Профиль завершен',
                profileCompletedWhatsNext:
                    'Знаете ли вы, что большинство работодателей используют онлайн-оценки в процессе приема на работу? Практикуйтесь сейчас и узнайте свои сильные и слабые стороны.',
                gotoTestsPage: 'Перейти в центр оценки',
                authIndication: {
                    title: 'Найдите работу своей мечты',
                    description:
                        'Вы хотите получить доступ к вакансиям, уникальным для вашей школы, и к тестам, которые помогут вам в поиске работы? С легкостью создайте пользователя в Google, LinkedIn или Facebook уже сегодня.',
                    action: 'Пойдем',
                },
                toProfileHint: 'К моему профилю',
                toProfileUncompletedHint:
                    'Ваш профиль не заполнен на 100%. Продолжайте, заполнив, чтобы максимально расширить ваши возможности трудоустройства.',
                profileActions: {
                    addFirstName: 'Добавить имя',
                    addLastName: 'Добавить фамилию',
                    addNationality: 'Добавить национальность',
                    addPhoneNumber: 'Добавьте свой номер телефона',
                    addLanguage: 'Добавить язык',
                    addEducation: 'Добавить образование',
                    addEmail: 'Добавьте свой адрес электронной почты',
                    addGender: 'Укажите свой пол',
                },
            },
            featuredCompanies: { label: 'Избранные компании' },
            featuredPositions: { label: 'Избранные позиции' },
            featuredResource: {
                header: 'Присоединяйтесь к виртуальной конференции',
                cta: 'Смотри!',
                wechatSignupHeader:
                    'Подпишитесь на учетную запись WeChat с высоким рейтингом, чтобы получать обновления',
            },
        },
    },
    cts: {
        filterNames: {
            employment_types: 'Типы занятости',
            education_level: 'Градусы',
            job_category: 'Поля',
            address: 'Локации',
            sector: 'Секторов',
            exclude_school_id: 'Исключать',
            languages: 'Языки',
        },
        excludeSchoolIds: {
            '-1': 'Общие сообщения',
            unknownSchoolId: 'Партнер школы EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Бакалавров',
            MASTERS_OR_EQUIVALENT: 'Мастера',
            DOCTORAL_OR_EQUIVALENT: 'КАНДИДАТ НАУК',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'На постоянной основе',
            INTERN: 'производственная практика',
            TEMPORARY: 'Неполная занятость',
            PART_TIME: 'Неполная занятость',
        },
        startDate: 'Начинать',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Бухгалтерский учет и финансы',
            ADMINISTRATIVE_AND_OFFICE: 'Административно-офисная',
            ADVERTISING_AND_MARKETING: 'Реклама и маркетинг',
            ART_FASHION_AND_DESIGN: 'Художественная мода и дизайн',
            BUSINESS_OPERATIONS: 'Деловые операции',
            COMPUTER_AND_IT: 'Компьютер и IT',
            CUSTOMER_SERVICE: 'Обслуживание клиентов',
            EDUCATION: 'Образование',
            HEALTHCARE: 'Здравоохранение',
            HUMAN_RESOURCES: 'Человеческие ресурсы',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Установка, обслуживание и ремонт',
            LEGAL: 'Юридическая',
            MANAGEMENT: 'Управление',
            MANUFACTURING_AND_WAREHOUSE: 'Производство и склад',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Медиа-коммуникации и письмо',
            OIL_GAS_AND_MINING: 'Энергия',
            PROTECTIVE_SERVICES: 'Защитные услуги',
            REAL_ESTATE: 'Недвижимость',
            SALES_AND_RETAIL: 'Продажи и розничная торговля',
            SCIENCE_AND_ENGINEERING: 'Наука и инженерия',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Социальные услуги и некоммерческие организации',
            TRANSPORTATION_AND_LOGISTICS: 'Транспорт и логистика',
        },
        sectors: {
            Consulting: 'Консультации',
            'Consumer Goods': 'Потребительские товары',
            'Financial Services / Banking': 'Финансовые услуги / Банковское дело',
            'Goverment / Public Administration / Non Profit':
                'Правительство / Государственное управление / Некоммерческая организация',
            'International Trade & Development': 'Международная торговля и развитие',
            Manufacturing: 'Производство',
            'Media / Entertainment': 'СМИ / Развлечения',
            'Petroleum / Energy': 'Нефть / Энергия',
            'Pharma / Healthcare / Biotech': 'Фарма / Здравоохранение / Биотехнологии',
            'Real Estate / Construction / Infrastructure':
                'Недвижимость / Строительство / Инфраструктура',
            'Technology (IT) / Telecom': 'Технологии (IT) / Телеком',
            'Transportations & Logistics': 'Транспорт и логистика',
            Other: 'Другой',
        },
        countries: {
            'China (Hong Kong SAR)': 'Гонконг',
            'Costa Rica': 'Коста-Рика',
            'Europe & Sub-Saharan Africa': 'Европа и Африка к югу от Сахары',
            'Hong Kong': 'Гонконг',
            'Korea, South': 'Южная Корея',
            'New Zealand': 'Новая Зеландия',
            'Papua-Ny Guinea': 'Папуа - Новая Гвинея',
            'Puerto Rico': 'Пуэрто-Рико',
            'Saudi Arabia': 'Саудовская Аравия',
            'South Africa': 'Южная Африка',
            'South Korea': 'Южная Корея',
            'Sri Lanka': 'Шри-Ланка',
            'Taiwan (Province of China)': 'Тайвань',
            'The Seychell Islands': 'Сейшельские острова',
            'United Arab Emirates': 'Объединенные Арабские Эмираты',
            'United Kingdom': 'объединенное Королевство',
            'Ivory Coast': "Кот-д'Ивуар",
            Afghanistan: 'Афганистан',
            Algeria: 'Алжир',
            Angola: 'Ангола',
            Argentina: 'Аргентина',
            Armenia: 'Армения',
            Australia: 'Австралия',
            Austria: 'Австрия',
            Azerbaijan: 'Азербайджан',
            Bahamas: 'Багамы',
            Bahrain: 'Бахрейн',
            Bangladesh: 'Бангладеш',
            Belarus: 'Беларусь',
            Belgium: 'Бельгия',
            Botswana: 'Ботсвана',
            Brazil: 'Бразилия',
            Bulgaria: 'Болгария',
            Cambodia: 'Камбоджа',
            Canada: 'Канада',
            Chile: 'Чили',
            China: 'Китай',
            Colombia: 'Колумбия',
            Congo: 'Конго',
            Croatia: 'Хорватия',
            Cyprus: 'Кипр',
            Czechia: 'Чехия',
            Denmark: 'Дания',
            Ecuador: 'Эквадор',
            Egypt: 'Египет',
            Estonia: 'Эстония',
            Ethiopia: 'Эфиопия',
            Fiji: 'Фиджи',
            Finland: 'Финляндия',
            France: 'Франция',
            Germany: 'Германия',
            Ghana: 'Гана',
            Greece: 'Греция',
            Guernsey: 'Гернси',
            Hungary: 'Венгрия',
            Iceland: 'Исландия',
            India: 'Индия',
            Indonesia: 'Индонезия',
            Iraq: 'Ирак',
            Ireland: 'Ирландия',
            Israel: 'Израиль',
            Italy: 'Италия',
            Japan: 'Япония',
            Jersey: 'Джерси',
            Jordan: 'Иордания',
            Kazakhstan: 'Казахстан',
            Kenya: 'Кения',
            Kuwait: 'Кувейт',
            Laos: 'Лаос',
            Latvia: 'Латвия',
            Lebanon: 'Ливан',
            Lithuania: 'Литва',
            Luxembourg: 'Люксембург',
            Malaysia: 'Малайзия',
            Malta: 'Мальта',
            Mauritania: 'Мавритания',
            Mauritius: 'Маврикий',
            Mexico: 'Мексика',
            Mongolia: 'Монголия',
            Morocco: 'Марокко',
            Myanmar: 'Мьянма',
            Namibia: 'Намибия',
            Netherlands: 'Нидерланды',
            Nigeria: 'Нигерия',
            Norway: 'Норвегия',
            Oman: 'Оман',
            Pakistan: 'Пакистан',
            Panama: 'Панама',
            Paraguay: 'Парагвай',
            Peru: 'Перу',
            Philippines: 'Филиппины',
            Poland: 'Польша',
            Portugal: 'Португалия',
            Qatar: 'Катар',
            Romania: 'Румыния',
            Russia: 'Россия',
            Senegal: 'Сенегал',
            Serbia: 'Сербия',
            Singapore: 'Сингапур',
            Slovakia: 'Словакия',
            Slovenia: 'Словения',
            Spain: 'Испания',
            Sudan: 'Судан',
            Swaziland: 'Свазиленд',
            Sweden: 'Швеция',
            Switzerland: 'Швейцария',
            Syria: 'Сирия',
            Taiwan: 'Тайвань',
            Tanzania: 'Танзания',
            Thailand: 'Таиланд',
            Tonga: 'Тонга',
            Turkey: 'Турция',
            Ukraina: 'Украина',
            Ukraine: 'Украина',
            USA: 'Соединенные Штаты Америки',
            Uzbekistan: 'Узбекистан',
            Vanuatu: 'Вануату',
            Vietnam: 'Вьетнам',
            Zambia: 'Замбия',
        },
        languages: {
            Aceh: 'Ачех',
            Afrikaans: 'африкаанс',
            Albanian: 'албанский',
            Amharic: 'Амхарский',
            Arabic: 'арабский',
            Arakanese: 'Араканский',
            Armenian: 'Армянский',
            Azeri: 'Азербайджанский',
            Badini: 'Бадини',
            Basque: 'Баскский',
            Belarusian: 'Белорусский',
            Bengali: 'Бенгальский',
            Berber: 'берберский',
            Bosnian: 'Боснийский',
            Bulgarian: 'болгарский',
            Burmese: 'Бирманский',
            Cantonese: 'Кантонский',
            Catalan: 'Каталонский',
            Cebuano: 'Себуано',
            Chechen: 'Чеченский',
            Chin: 'Подбородок',
            Chinese: 'китайский язык',
            Croatian: 'хорватский',
            Czech: 'Чешский',
            Danish: 'Датский',
            Dari: 'Дари',
            Dutch: 'Голландский',
            English: 'английский',
            Estonian: 'эстонский',
            Faroese: 'Фарерские острова',
            Filipino: 'Филиппинский',
            Finnish: 'Финский',
            French: 'французский язык',
            German: 'Немецкий',
            Greek: 'Греческий',
            Greenlandic: 'Гренландский',
            Hausa: 'Хауса',
            Hebrew: 'иврит',
            Hindi: 'хинди',
            Hungarian: 'Венгерский',
            Icelandic: 'исландский',
            Indonesian: 'индонезийский',
            Italian: 'Итальянский',
            Japanese: 'Японский',
            Kazakh: 'Казахский',
            Kinyarwanda: 'Киньяруанда',
            Kirundi: 'Кирунди',
            Korean: 'Корейский',
            Kurdish: 'Курдский',
            Kurmanji: 'Курманджи',
            Kven: 'Квен',
            Latin: 'латинский',
            Latvian: 'Латышский',
            Lingala: 'Лингала',
            Lithuanian: 'Литовский',
            Macedonian: 'македонский',
            Malagasy: 'Малагасийский',
            Malaysian: 'Малазийский',
            Mandarin: 'Мандаринский',
            Mongolian: 'Монгольский',
            Nepali: 'Непальский',
            Norwegian: 'Норвежский',
            Oromo: 'Оромо',
            Other: 'Другой',
            Panjabi: 'Панджаби',
            Pashto: 'Пушту',
            Persian: 'Персидский',
            Polish: 'Польский',
            Portuguese: 'португальский',
            Punjabi: 'Пенджаби',
            Romanes: 'Romanes',
            Romani: 'Цыганский',
            Romanian: 'румынский',
            Russian: 'русский',
            Sami: 'Саами',
            Serbian: 'сербский',
            Sign_language: 'Язык знаков',
            Slovak: 'словацкий',
            Slovene: 'Словенский',
            Somali: 'Сомалийский',
            Sorani: 'Сорани',
            Spanish: 'испанский язык',
            Swahili: 'суахили',
            Swedish: 'Шведский',
            Tagalog: 'Тагальский',
            Tamil: 'Тамильский',
            Thai: 'Тайский',
            Tigrinya: 'Тигринья',
            Turkish: 'турецкий',
            Ukrainian: 'украинец',
            Urdu: 'Урду',
            Uyghur: 'Уйгурский',
            Vietnamese: 'вьетнамский',
            Wolof: 'Волоф',
        },
    },
    emailverification: {
        headerLabel: 'Подтверждение адреса электронной почты',
        verifyingEmail: 'Проверка электронной почты',
        emailVerifySuccess: 'Ваш e-mail проверен!',
        emailVerifyFailure:
            'Что-то пошло не так ... попробуйте позже или обратитесь в службу поддержки',
        gotoMyPage: 'Вернуться на мою страницу',
    },
    errors: {
        defaultErrorMessage: 'Произошла ошибка!',
        logInErrorText: {
            invalidCredentials: 'Неправильный логин или пароль',
            inactiveUser:
                'Пользователь с предоставленным адресом электронной почты неактивен. Проверьте свою электронную почту на предмет активации аккаунта или попробуйте сбросить пароль.',
            default: 'Не удалось пройти аутентификацию.',
        },
        registerErrorText: {
            passwordTooShort: 'Пароль должен состоять как минимум из 8 цифр.',
            emailAlreadyInUse: 'Предоставленный адрес электронной почты уже используется.',
            emailTaken:
                'Почтовый адрес уже используется. Если вы использовали школьную электронную почту, это могло произойти из-за того, что у вас был пользователь до обновления платформы (на сайте highheredtalent.org).',
            default: 'Не удалось создать пользователя.',
        },
        invalidTokenText: {
            default: 'Ваш токен недействителен или срок его действия истек.',
        },
        passwordErrorText: {
            passwordTooShort: 'Пароль должен состоять как минимум из 8 цифр.',
            requireNonAlphanumeric: 'Пароль должен содержать хотя бы один специальный символ.',
            requireLowerCase: 'Пароль должен содержать хотя бы одну строчную букву.',
            requireUpperCase: 'Пароль должен содержать хотя бы одну заглавную букву.',
            requireUniqueChars: 'Пароль должен содержать не менее 6 разных символов.',
            default: 'Не удалось сменить пароль',
        },
        recoverErrorText: {
            userNotFound: 'Пользователь не существует! Обратитесь в службу поддержки.',
            userAlreadyActive: 'Пользователь уже активирован! \\ NПопробуйте войти.',
            emailAlreadyInUse:
                'Указанный адрес электронной почты уже используется. \\ NЕсли вы хотите продолжить активацию учетной записи, попробуйте использовать другой адрес электронной почты или другой вход в социальную сеть. В противном случае перейдите на главную страницу и войдите в свою учетную запись.',
            default: 'Не удалось активировать учетную запись. \\ NПовторите попытку позже.',
        },
        socialAuthErrorText: {
            errorTitle: 'Не удалось войти через {provider}',
            invalidProviderGoogle:
                'Пользователь с указанным адресом электронной почты не связан с Google. Попробуйте, например, войти в систему с помощью LinkedIn, Facebook или электронной почты.',
            invalidProviderFacebook:
                'Пользователь с указанным адресом электронной почты не связан с Facebook. Попробуйте, например, войти в систему с помощью Google, LinkedIn или электронной почты.',
            invalidProviderLinkedIn:
                'Пользователь с указанным адресом электронной почты не связан с LinkedIn. Попробуйте, например, войти в систему с помощью Google, Facebook или электронной почты.',
            invalidProviderWeChat:
                'Пользователь с указанным адресом электронной почты не связан с WeChat. Попробуйте, например, войти в систему с помощью Google, Facebook или электронной почты.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'Указанный вами адрес электронной почты уже используется. Это может быть связано с тем, что у вас был пользователь до обновления платформы (на сайте highheredtalent.org). Обратитесь в службу поддержки.',
            invalidEmailDomain:
                'Указанный адрес электронной почты не соответствует указанному университету. Пожалуйста, выберите правильный университет.',
            existingConnection: 'Пользователь уже подключен к указанному университету',
            default: 'Не удалось инициировать проверку.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'Почтовый адрес уже используется',
                default: 'Не удалось обновить',
            },
        },
    },
    favorites: {
        header: 'Мои любимые',
        active: 'Активный',
        expired: 'Истекший',
        expiresThisMonth: 'Срок подачи заявок в этом месяце',
        expiresThisWeek: 'Срок подачи заявок на этой неделе',
        expiresLater: 'Срок подачи заявок позже',
        noActiveFavorites: 'У вас нет активных любимых позиций',
        noExpired: 'У вас нет избранных позиций с истекшим сроком действия',
    },
    findcompanies: {
        headerLabel: 'Найти компании',
        companyListLabel: 'Компании',
    },
    findjobs: {
        header: 'Найти работу',
        changeFilters: 'Изменить фильтры',
        recruitmentModule: {
            body: 'Вы кадровый специалист, профессиональный специалист или просто \\ n заинтересованы в найме талантливых студентов?',
            createJob: 'Нажмите здесь, чтобы создать вакансию',
        },
    },
    general: {
        documentTitle: 'Платформа глобальных возможностей',
        email: 'Электронное письмо',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        loading: 'Загрузка',
        ok: 'хорошо',
        save: 'Сохранить',
        add: 'Добавлять',
        close: 'Закрывать',
        delete: 'Удалить',
        cancel: 'Отмена',
        done: 'Готово',
        continue: 'Продолжать',
        back: 'Назад',
        next: 'Следующий',
        finish: 'Заканчивать',
        success: 'Успех',
        error: 'Ошибка',
        description: 'Описание',
        months: {
            0: 'Янв',
            1: 'Фев',
            2: 'Мар',
            3: 'Апр',
            4: 'Май',
            5: 'Июн',
            6: 'Июл',
            7: 'Авг',
            8: 'Сен',
            9: 'Октябрь',
            10: 'Ноя',
            11: 'Декабрь',
        },
        days: {
            0: 'солнце',
            1: 'Пн',
            2: 'Вт',
            3: 'Мы б',
            4: 'Четверг',
            5: 'Пт',
            6: 'Суббота',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Проверка ожидающей проверки',
                verifySchoolConnection:
                    'Подтвердите подключение к школе, чтобы получить доступ к этим ресурсам',
                logInToAccessMoreFeatures: 'Тысячи возможностей для международной карьеры',
            },
        },
        minutesShort: 'мин',
        poweredBy: 'Питаться от',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: 'Эта компания имеет сертификат «Отличное место для работы».',
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: 'Этот пост принадлежит компании "Отличное место для работы"',
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName} сертифицировано как отличное место для работы',
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                    readMore: 'Нажмите, чтобы узнать больше',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Срок подачи заявок',
            location: 'Расположение',
            employmentType: 'Вид занятости',
            languageRequirements: 'Языковые требования',
            workPermitRequirements: 'Требования к разрешению на работу',
            preferredEducationField: 'Предпочтительное образование',
            preferredEducationLevel: 'Желаемый уровень образования',
            jobTags: 'Теги',
            apply: 'Применить сейчас',
            verificationRequired:
                'Чтобы подать заявку, вам необходимо подтвердить свой школьный адрес электронной почты.',
            verificationRequiredHint:
                'Чтобы подать заявку, вам необходимо подтвердить свой школьный адрес электронной почты',
            verificationPending: 'У вас есть ожидающая подтверждения в этой школе',
            verificationPendingHint: 'У вас есть ожидающая подтверждения в этой школе',
        },
        invalidJobAd: {
            caption:
                'Извините, но мы не смогли найти эту позицию. Если вы считаете, что это ошибка, обратитесь в службу поддержки, используя окно чата ниже.',
            btn: 'Найти другую работу',
        },
    },
    mypage: {
        header: 'Моя страница',
        suggestedPositions: 'Предлагаемые должности',
        favoriteModule: {
            header: 'Мои любимые позы',
            seeAll: 'Увидеть все',
            noFavorites: 'У вас нет активных любимых позиций',
        },
    },
    recoverpassword: {
        createPassword: 'Создать новый пароль',
        newPasswordLabel: 'Новый пароль',
        newPasswordPlaceholder: 'Пароль',
        confirmPasswordLabel: 'Подтвердите пароль',
        confirmPasswordPlaceholder: 'Подтвердите пароль',
        resetPasswordButton: 'Сброс пароля',
        resettingPassword: 'Сброс пароля',
        passwordsNotMatching: 'Пароли не соответствуют.',
    },
    recoveruser: {
        headerLabel: 'Восстановить более высокого пользователя',
        accountActivation: 'Активация аккаунта',
        step1: {
            header: 'Добро пожаловать на нашу новую платформу!',
            subHeader: 'Выберите, как вы хотите подключиться к своей учетной записи',
            description:
                'Для упрощения процесса входа мы рекомендуем вам подключить свою учетную запись хотя бы к одной из следующих служб.',
            OR: 'или',
            emailAndPassword: 'Используйте свою электронную почту',
        },
        step2: {
            header: 'Используйте электронную почту и пароль',
            description:
                'Это основной адрес электронной почты, который будет связан с вашей учетной записью. Мы рекомендуем использовать адрес электронной почты, отличный от адреса университета, чтобы сохранить доступ к своим данным после окончания учебы. Вы можете легко контролировать, какие электронные письма вы получаете от нас, в настройках своей учетной записи.',
            invalidEmail: 'Указанный адрес электронной почты не является действительным.',
            passwordsNotMatch: 'Пароли должны совпадать',
            passwordDescription01:
                'Для обеспечения безопасности вашей учетной записи вам необходимо установить новый пароль. Пожалуйста, создайте пароль со следующим:',
            passwordDescription02: 'Минимум 8 символов',
            passwordDescription03: 'По крайней мере, один символ нижнего регистра (a-z)',
            passwordDescription04: 'По крайней мере, один символ верхнего регистра (A-Z)',
            passwordDescription05:
                'По крайней мере, одна цифра или специальный символ (0-9,! # $ И т. Д.)',
            passwordDescription06: 'По крайней мере 6 уникальных персонажей',
            repeatPassword: 'Повторите пароль',
        },
        step3: {
            header: 'Активация пользователя',
            loadingHints: {
                0: 'Загрузка пользовательских данных',
                1: 'Готовим все',
                2: 'Новые возможности за углом',
                3: 'Почти сделано!',
            },
            successHeader: 'Теперь ваша учетная запись готова к работе!',
            successSubheader: 'Теперь вы можете получить доступ к новым эксклюзивным функциям!',
            errorHeader: 'Не удалось активировать аккаунт',
            ifWrongContact: 'Если вы считаете, что это неправильно, обратитесь в службу поддержки.',
            contactForHelp: 'Обратитесь за помощью',
            goBack: 'Вернись',
        },
    },
    resourcesInternal: {
        header: 'Ресурсы',
        resourceTypeHeader: 'Тип',
        resourceNoContent: 'В вашей школе еще не активирована функция ресурса.',
        resourceFolderNoContent: 'В этой папке нет доступных ресурсов',
        resourceTitleHeader: 'Заголовок',
        resourcePublishDateHeader: 'Опубликовано',
        searchPlaceholder: 'Найдите имя или ключевое слово ...',
        cvTemplateHeader: 'ШАБЛОН ВЫСШЕГО РЕЗЮМЕ (ДРУЖЕСТВЕННЫЙ ДЛЯ ATS)',
        cvTemplateSubtitle: 'Скачать здесь!',
    },
    shared: {
        userNavSection: {
            myPage: 'Моя страница',
            myProfile: 'Мой профайл',
            myTests: 'Оценки',
            myApplications: 'Приложения',
            myFavorites: 'Избранное',
            resources: 'Ресурсы',
            calendar: 'Календарь',
            documents: 'CV Загрузить',
        },
        searchModule: {
            searchBar: { label: 'Поиск по названию или ключевым словам' },
            filters: { clearFilters: 'Очистить фильтры' },
            filterLimit: {
                title: 'Достигнут предел фильтра',
                message: 'Больше нельзя выбрать фильтры этого типа.',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Позиции',
                estimatedCount: 'ca {count} из {totalCount}',
                knownCount: '{count} из {totalCount}',
                noMatchFound: 'Не удалось найти ничего, что соответствует вашим критериям',
            },
            postItem: { applyBefore: 'Срок подачи заявок' },
            postCard: { deadline: 'Срок' },
        },
        loginModule: {
            emailVerificationTip:
                'Он может добраться до вашего почтового ящика через несколько минут.',
            noEmail: 'Нет электронной почты? Пожалуйста, проверьте свой спам-фильтр или:',
            logIn: 'Авторизоваться',
            socialAuthBtns: {
                continueWithFacebook: 'Продолжить с Facebook',
                continueWithGoogle: 'Продолжить с Google',
                continueWithLinkedIn: 'Продолжить с LinkedIn',
                continueWithWeChat: 'Продолжить с WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Пожалуйста, подтвердите свою электронную почту',
                weSentAnEmailTo: 'Мы отправили подтверждение на',
                continueToSignIn: 'Продолжить вход',
                resendEmail: 'Отправить ссылку для подтверждения еще раз',
                newEmailSent: 'Новое письмо отправлено',
            },
            registerForm: {
                recommendation:
                    'Мы рекомендуем вам использовать свой личный адрес электронной почты, а не \\ n школьный, чтобы иметь доступ к своим данным после \\ n выпуска.',
                register: 'регистр',
                passwordsNotMatch: 'пароли не совпадают',
            },
            logInPaper: {
                useEmail: 'или используйте свою электронную почту',
                noAccount: 'Нет учетной записи?',
                signUp: 'Зарегистрироваться',
                logInToAccess: 'Войдите, чтобы получить доступ к этой функции',
                showAllOptions: 'Показать все варианты входа',
                hideAllOptions: 'Показывай меньше',
            },
            logInForm: { logIn: 'Авторизоваться', forgotPassword: 'Забыли пароль?' },
            forgotPassword: {
                title: 'Запросить сброс пароля',
                description:
                    'Не беспокойтесь - все время от времени забывают свой пароль. \\ N Введите свой адрес электронной почты ниже, чтобы сбросить пароль',
                resetPassword: 'Сброс пароля',
                emailSentTitle: 'Ваша помощь уже в пути!',
                emailHasBeenSent:
                    'На \\ n <br> \\ n <strong> {email} </strong> \\ n <br> \\ n было отправлено письмо с инструкциями по изменению пароля. Пожалуйста, проверьте свой \\ n почтовый ящик.',
                noEmail: 'Нет электронной почты?',
                sendEmailOneMoreTime: 'Отправить письмо еще раз',
                resendErrorTitle: 'Ошибка при восстановлении пароля',
                resendErrorMessage:
                    'Не удалось отправить электронное письмо для восстановления пароля. Может неправильный емайл?',
            },
        },
        termsAndConds: {
            termsAndConditions: 'Условия и положения',
            privacyPolicy: 'Политика конфиденциальности',
            talentPanel: 'Школа / Работодатель?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Удалено',
                deletedTitle: 'Эта позиция больше не доступна',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Похоже, страницы, которую вы искали, больше нет.',
            goToHome: 'Вернуться на домашнюю страницу',
            contactus: 'Свяжитесь с нами',
        },
        chat: {
            liveNow: 'Живи в чате прямо сейчас!',
            seeAll: 'Все',
            schoolSpecificChats: 'Быстрый доступ',
            help: 'Нужна помощь?',
            chatExistsLabel: 'Чат существует',
        },
        countdown: {
            day: 'день',
            days: 'дней',
            hour: 'час',
            hours: 'часы',
            minute: 'минута',
            minutes: 'минут',
            second: 'второй',
            seconds: 'секунды',
        },
    },
    spotlight: {
        header: 'Мой профайл',
        saveChangesToSubmit: 'Сохраните свой профиль, чтобы изменения вступили в силу',
        saveChanges: 'Сохранить изменения',
        saveSuccessful: 'Ваши изменения были успешно сохранены',
        personalDetails: {
            header: 'Личные данные',
            firstName: 'Имя',
            lastName: 'Фамилия',
            nationality: 'Национальность',
            gender: 'Пол',
            uploadProfileImage: 'Загрузить фото',
            genderOptions: {
                male: 'Мужской',
                female: 'Женский',
                other: 'Другой',
                none: 'Предпочитаю не говорить',
                unknown: 'Неизвестный',
            },
            wrongFileTypeErrorHeader: 'Неверный тип файла',
            wrongFileTypeErrorDescription: 'Вы можете загружать только изображения',
        },
        summary: { header: 'Управляющее резюме' },
        contactDetails: {
            header: 'Контактная информация',
            contactEmail: 'Почта для связи',
            phoneNumberHeader: 'номер мобильного телефона',
            countryCode: 'Код страны',
            phoneNumber: 'Телефонный номер',
            invalidEmail: 'Набранный адрес электронной почты не является действительным.',
            permanentEmail:
                'ПРИМЕЧАНИЕ. Это изменение является постоянным. Вы можете установить свой адрес электронной почты только один раз.',
        },
        languages: {
            header: 'Языки',
            languageLabel: 'Язык',
            levelLabel: 'Уровень',
            addLanguage: 'Добавить новый язык',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Элементарное владение',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Ограниченное рабочее знание языка',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Профессиональное владение',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Полное профессиональное владение',
                '250d296e-d6db-46fb-8c44-07950db80ec4':
                    'Носитель языка, или свободно владеющий двумя языками',
            },
        },
        education: {
            header: 'Образование',
            addEducation: 'Добавить образование',
            notGraduated: 'Еще не закончил',
            graduatedIn: 'Выпускник {date}',
            dialog: {
                addNewEducation: 'Добавить новое образование',
                degreeTitle: 'Программа',
                institution: 'Учреждение',
                degreeType: 'Степень',
                fieldOfStudy: 'Область изучения',
                cannotFindField: 'Я не могу найти свое поле',
                studyStart: 'Месяц начала',
                studyEnd: 'Выпускной месяц',
                invalidDegreeTitle: 'Вам необходимо указать название вашей программы.',
                invalidSchool: 'Вам нужно выбрать школу.',
                invalidStartDate: 'Пожалуйста, выберите дату начала.',
                invalidEndDate: 'Пожалуйста, выберите дату окончания.',
                invalidStudyPeriod: 'Вы не можете закончить обучение до даты начала обучения.',
                invalidDegreeField: 'Пожалуйста, введите действительную область обучения.',
                invalidDegreeLevel: 'Пожалуйста, выберите действительный уровень вашей степени.',
                selectStartDate: 'Дата начала',
                selectEndDate: 'Дата выпуска',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Бакалавр',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Владелец',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'КАНДИДАТ НАУК',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Сельское и лесное хозяйство',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Прикладные науки и профессии',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Искусство, дизайн и архитектура',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Управление бизнесом',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Компьютерные науки и ИТ',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Экономика',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Образование и обучение',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Инженерная технология',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Экологические исследования и науки о Земле',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Гостиничный бизнес, отдых и спорт',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Гуманитарные науки',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Журналистика и СМИ',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Закон',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Маркетинг',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                        'Магистр наук в области инноваций и бизнеса',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Магистр управления развитием',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Магистр наук в области науки о данных',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Медицина и здоровье',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'Магистр финансов',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4':
                        'Магистр международных бизнес-исследований',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'Магистр бизнес-аналитики',
                    '7d832109-642a-4730-aada-26927eb683ee': 'MS в управлении',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Естественные науки и математика',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Социальные науки',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Другой',
                },
            },
        },
        workAuthorization: {
            header: 'Разрешение на работу',
            addWorkAuthorization: 'Добавить разрешение на работу',
            implicitValue: 'На основании вашей национальности',
            dialog: {
                selectCountry: 'Выберите страну',
                addEuWorkAuthorization: 'Добавить разрешение на работу в ЕС',
            },
        },
        communication: {
            header: 'Коммуникация',
            sendMeUpdatesDescription:
                'Присылайте мне карьерные новости, должности и обновления компании по электронной почте',
        },
        errors: {
            imageUpload: {
                title: 'Не удалось загрузить изображение.',
                message: 'Изображение слишком велико!',
            },
        },
        exitDialog: {
            title: 'Несохраненные изменения будут потеряны',
            message:
                'Вы пытаетесь выйти со страницы без сохранения изменений. Вы хотите сохранить свой профиль, прежде чем двигаться дальше?',
            stayAction: 'Оставайтесь на этой странице',
            saveAction: 'Сохранить профиль',
            continueAction: 'Продолжить без сохранения',
        },
    },
    tests: {
        header: 'Тесты',
        unauthorized:
            'В настоящее время тесты находятся в стадии закрытого бета-тестирования. У вас пока нет доступа к этим функциям. Скоро они будут доступны!',
        error: 'Что-то пошло не так при попытке загрузить тесты. Пожалуйста, повторите попытку позже.',
        assessmentModule: { header: 'Ваша оценка' },
        completedYourProfile:
            'Вам необходимо заполнить свой профиль, чтобы получить доступ к этому экзамену',
        toMyProfile: 'Редактировать мой профиль',
    },
    vfair: {
        header: 'Виртуальные события EFMD',
        activeNow: 'Непрерывный',
        visibilityPrivate: 'Частный',
        visibilityNetwork: 'Сеть',
        visibilityOpen: 'Открыть',
        interested: 'регистр',
        attend: 'Приехать на мероприятие',
        enterEvent: 'Введите виртуальное событие',
        notinterested: 'Меня больше не интересует',
        shownInterest: 'Зарегистрировано',
        signUpToday: 'Зарегистрироваться Сегодня!',
        vfairsInfo:
            'Общайтесь с компаниями и организациями со всего мира в сложной среде моделирования ярмарки вакансий, которая позволяет в реальном времени взаимодействовать между рекрутерами и кандидатами. Нажмите на интересующее вас виртуальное событие и зарегистрируйтесь, чтобы получать уведомления.',
        recruitingOrgs: 'Рекрутинговые компании и организации',
        preRegistered: 'Предварительная регистрация',
        prepareForTheFair: 'Подготовьтесь к виртуальному мероприятию',
        privateVFairHeader: 'Виртуальное мероприятие в кампусе',
        privateVFairMessage:
            'Это виртуальное мероприятие проводится на школьной платформе EFMD и поэтому не может быть доступно отсюда.',
        schoolNotJoinedNetworkEventMessage:
            'Ваша школа еще не подписалась на это виртуальное мероприятие, обратитесь к директору программы или в отдел карьеры, чтобы попросить об участии.',
        companyNotJoinedNetworkEventMessage:
            'У вашей организации нет действующей виртуальной будки на этом мероприятии. Обратитесь к Highered, чтобы попросить об участии.',
        pavilions: 'Павильоны',
        general: 'Общий',
        allCompanies: 'Все компании',
        lobby: 'Лобби',
        inviteCode: 'Пригласительный код',
        eventRequiresInvitation: 'Для этого мероприятия требуется приглашение',
        haveCode: 'у меня есть код',
        checkCode: 'Проверить код',
        invalidCode: 'Неверный код',
        registeredSuccessfully: 'Регистрация прошла успешно',
        pavilionTabs: {
            home: 'домашняя страница',
            companies: 'компании',
            articles: 'статьи',
            jobs: 'работа ',
            events: 'События',
        },
        events: {
            noEventsAvailable: 'Нет доступных событий',
            showCompleted: 'Показать завершеное',
            hideCompleted: 'Скрыть завершеное',
            liveNow: 'Живи сейчас',
            joinTheEvent: 'Присоединяйтесь к мероприятию',
            addToCalendar: 'Добавить в календарь',
        },
        links: {
            masterclasses: {
                header: 'Мастер-классы',
                buttonCaption: 'Смотрите мастер-классы',
                description:
                    'Просмотрите широкий спектр высококачественных мастер-классов, включая «Оптимизация резюме для приема на работу», «Улучшите свой профиль в Linkedin» и «Переговоры по заработной плате», среди многих других, для всех этапов вашей карьерной траектории!',
            },
            detailsmasterclass: { header: 'Посетить мастер-класс' },
            cv: {
                header: 'Шаблон резюме',
                buttonCaption: 'Скачать шаблон резюме',
                description:
                    'Получите доступ к шаблону CV, удобному для ATS, чтобы произвести оптимальное профессиональное впечатление на рекрутеров.',
            },
            elevatorPitch: {
                header: 'Испытание Pitch Challenge',
                buttonCaption: 'Отправьте свою презентацию',
                description:
                    'Примите участие в «Pitch Perfect Challenge»! Это ваша возможность рассказать о своей ценности сотням рекрутеров из ведущих мировых компаний и организаций!',
            },
        },
        footerHeaders: {
            social: 'Следуйте за нами, чтобы узнать больше',
            sponsored: 'При финансовой поддержке',
            organized: 'Организованный',
        },
        educationPopup: {
            step00: {
                header: 'Поделись своим образованием',
                subtitle: 'Чтобы продолжить, расскажите о себе больше работодателям.',
                continueLabel: 'Добавить мое образование',
                leaveLabel: 'Увольнять',
            },
            step01: { header: 'Расскажите нам о своем образовании' },
            step02: { loadingLabel: 'Момент...' },
            step03: {
                header: 'Обучение закончено',
                subtitle:
                    'Теперь вы можете поделиться своим профилем и быть более интересным для работодателей',
                continueLabel: 'Продолжить знакомство с виртуальным событием',
            },
            error: {
                header: 'Упс! Произошла ошибка!',
                subtitle:
                    'Нам не удалось сохранить вашу образовательную информацию. Пожалуйста, повторите попытку позже.',
            },
        },
    },
};
